var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-nav',[_c('b-dropdown-item',{attrs:{"href":"#"}},[_c('b-icon',{attrs:{"icon":"shop"}}),_c('router-link',{attrs:{"to":"/clientes"}},[_vm._v(" Cadastro de Clientes")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }